import { Component, ElementRef, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormArray, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgProgressRef, NgProgress } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { Lang, ListParams, PaginationInput, PaginationPageEvent, Res } from 'src/app/models';
import { ApiOrganizationsService, ApiReferencesService, DatetimeService, DialogModalService, LanguageService, NotificationService, PermissionService, ValidatorsService } from 'src/app/services';
import { DirectoryDeleteComponent } from '../directory-delete/directory-delete.component';
import { ReferenceValidator } from '../references-actions.validator';

@Component({
  selector: 'app-rereferences-actions',
  templateUrl: './rereferences-actions.component.html',
  styleUrls: ['./rereferences-actions.component.css']
})
export class RereferencesActionsComponent implements OnInit {

  paginationInput: PaginationInput;
  paginationOutput: PaginationPageEvent;
  listParams: ListParams;
  referenceId: string = '';
  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  errorMessages: any;
  loading: boolean;
  deletedData: string[] = [];
  organizations: any[] = [];
  editData: any;
  searchResult: boolean = true;
  search: string = '';
  referenceName: Lang;
  referenceElementName: Lang[] = [];
  indexIterrator: number = 1;
  ffInputLang: any = { name: '', valid: false };
  ffInputLangParams = {
    name: {
      clearField: true,
      required: true
    }
  }

  @ViewChildren('element', { read: ElementRef })
  elements: QueryList<ElementRef>;

  @Input() set data(value) {

    console.log("REFERENCE ID:", value);


    if (value != null) {
      this.referenceId = value.reference_id;
    }
  }



  form: UntypedFormGroup = this.fb.group({
    id: [null],
    org_id: [null],
    name: [null],
    data: this.fb.array([]),
    deleted_references_data: [null]
  });

  formName: UntypedFormGroup = this.fb.group({
    name: [null],
  });

  constructor(
    public ngProgress: NgProgress,
    private fb: UntypedFormBuilder,
    public activeModal: NgbActiveModal,
    private languageService: LanguageService,
    private apiReferences: ApiReferencesService,
    private notification: NotificationService,
    private validator: ReferenceValidator,
    private validatorService: ValidatorsService,
    public permissionAccess: PermissionService,
    private dialogModal: DialogModalService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.errorMessages = this.validator.errorMessages;


    if (this.permissionAccess.check('REFERENCES_ORGANIZATIONS')) {
      this.getOrganizations();
    }

    this.referenceId ? this.onEdit() : this.addReferenceFields();

    // if (this.referenceId) {

    //   this.onEdit();
    // }


    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }


  /**
   * 
   * @param fieldName 
   * @param value 
   */
  eventFnFF(fieldName: string, value: any): void {

    this.ffInputLang = value;

    this.form.controls[fieldName].setValue(value.name);
  }


  /**
   * 
   * @param fieldName 
   * @param value 
   */
  eventArrayFnFF(i: number, fieldName: string, value: any): void {

    this.ffInputLang = value;

    this.form.get(['data', i, fieldName]).setValue(value.name);
  }

  /**
  * 
  * @param type string
  */
  addReferenceFields(): void {

    let control = this.form.controls.data as UntypedFormArray;

    if (control.length > 0) {

      this.indexIterrator = +this.form.get(['data', control.length - 1, 'id']).value;

      this.indexIterrator++;

    }

    control.push(this.initReferencesFields(control.length));

    setTimeout(() => this.elements.last.nativeElement.firstChild[1].focus());
  }

  /**
   * 
   * @returns 
   */
  initReferencesFields(i: number): any {

    this.referenceElementName[i] = null;

    return this.fb.group({
      id: [this.indexIterrator, this.validator.id],
      name: [null, this.validator.name],
      parent_id: [null],
      row_id: [null]
    });
  }

  /**
   * 
   */
  referencesControlDelete(i: number) {


    if (this.form.get(['data', i, 'row_id']).value) {

      let data = {
        reference_id: [this.referenceId],
        row_id: this.form.get(['data', i, 'row_id']).value
      }

      this.dialogModal.open(data, DirectoryDeleteComponent).then(

        (result) => {

          if (result) {

            this.removeReferenceField(i);
          }
        },
        () => { console.log('Rejected!'); }
      );

    } else {

      this.removeReferenceField(i);
    }

  }

  /**
   * 
   * @param i number
   */
  removeReferenceField(i: number): void {


    if (this.form.get(['data', i, 'row_id']).value != null) {

      this.deletedData.push(this.form.get(['data', i, 'row_id']).value)

      this.form.controls.deleted_references_data.setValue(this.deletedData);
    }

    let control = this.form.controls.data as UntypedFormArray;
    control.removeAt(i);

    //обновляем наименование элемента беря значение из формы, которая хранит текущие значения, 
    //потому что после удаления элемента, смещается и его индекс, а переменная хранящее значение
    //автоматически перезаписывается на удаленный индекс
    for (let j = 0; j < this.form.controls.data.value.length; j++) {

      this.referenceElementName[j] = this.form.get(['data', j, 'name']).value;
    }

    if (this.referenceId) {
      this.onUpdate(true);
    }


  }

  /**
   * 
   */
  searchReferencesElement() {

    console.log("SEARCH: ", this.search);

    this.removeField();

    this.onEdit();


  }

  /**
   * 
   */
  clearingSearch() {

    this.search = "";

    this.removeField();

    this.onEdit();
  }

  /**
   * 
   */
  removeField() {

    let control = this.form.controls.data as UntypedFormArray;

    control.controls.splice(0, control.length);

  }



  /**
   * 
   * @param referenceData 
   */
  setDataInForm(referenceData) {

    this.referenceName = referenceData.name;

    this.form.patchValue({
      id: referenceData.id,
      org_id: referenceData.org_id
    });

    if (this.referenceId) {

      this.form.get('org_id').disable();
    }

    if (referenceData.data != null) {

      for (let data of referenceData.data) {

        this.addReferenceFieldsWithdata(data);
      }
    }
  }

  /**
   * 
   * @param type string
   */
  addReferenceFieldsWithdata(referenceData: any): void {

    let control = this.form.controls.data as UntypedFormArray;
    control.push(this.setReferenceData(referenceData, control.length));
  }

  /**
   * 
   * @param referenceData 
   * @returns 
   */
  setReferenceData(referenceData: any, index: number) {

    this.referenceElementName[index] = referenceData.name;

    return this.fb.group({
      id: [{ value: referenceData.id, disabled: true }],
      name: referenceData.name,
      parent_id: referenceData.parent_id,
      row_id: referenceData.row_id
    });

  }

  /**
   * 
   */
  getOrganizations(searchValue: string = ''): void {

    this.organizations = [];

    let data = {
      ref_name: 'organizations',
      filter: {
        name: searchValue,
        sort: 'all'
      }
    }

    this.subscriptions.add(
      this.apiReferences.getReferences(data, data.ref_name).subscribe((response: Res) => {
        console.log('[RESPONSE] getOrganizations: ', response);

        if (response != null) {

          this.organizations = response.result;

        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );
  }


  /**
 * 
 * @param event 
 */
  pageEvent(event: PaginationPageEvent): void {

    this.paginationOutput = event;
    this.removeField();
    this.onEdit();
  }


  /**
 * 
 */
  setListReferences(): void {

    this.listParams = {
      filter: {
        id: this.referenceId,
        name: this.search
      },
      object: 'reference_data',
      pageNumber: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 1 : this.paginationOutput.pageNumber,
      countOnPage: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 10 : this.paginationOutput.pageSize
    }
  }

  /**
   * 
   */
  onEdit(): void {

    this.progressRef.start();
    this.loading = true;
    this.searchResult = false;
    this.editData = [];

    this.setListReferences();

    this.subscriptions.add(

      this.apiReferences.referenceDataEdit(this.listParams).subscribe((response: Res) => {
        console.log('[RESPONSE] REFERENCE_EDIT_DATA: ', response);

        if (response != null && response.result != null) {

          this.editData = response.result.list;
          this.setDataInForm(response.result.list);
          this.organizations.push({ id: this.editData.org_id, name: this.editData.org_name })

          this.paginationInput = {
            count: response.result.count,
            numberOfPages: response.result.numberOfPages,
            currentPage: this.listParams.pageNumber,
            size: this.listParams.countOnPage
          }

          this.searchResult = true;

        }
        this.progressRef.complete();
        this.loading = false;
      },
        error => {
          this.progressRef.complete();
          this.loading = false;
        })
    );
  }


  /**
   * 
   */
  onCreate(): void {

    let form = { ...this.form.value };

    this.progressRef.start();

    this.subscriptions.add(
      this.apiReferences.create(form).subscribe((response: Res) => {
        console.log('[RESPONSE] saveReference: ', response);

        if (response != null) {

          this.notification.show('success', 'Данные успешно сохранены');
          this.activeModal.close(response);
        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );
  }

  /**
   * 
   */
  onUpdate(updateState:boolean = false) {

    let form = { ...this.form.value };

    this.progressRef.start();

    this.subscriptions.add(
      this.apiReferences.update(form).subscribe((response: Res) => {
        console.log('[RESPONSE] UPDATE_REF: ', response);

        if (response != null) {

          this.notification.show('success', 'Данные успешно сохранены!');
          if(!updateState) this.activeModal.close(response);
        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );
  }

  /**
  * 
  * @param field 
  * @param type 
  */
  validation(field: string, type: string): boolean {

    return this.validatorService.validation(this.form.get(field), type);
  }

}
